import { isMobile } from '../../scripts/helpers';

export default class CardLoad {
  constructor() {
    var cardsLoad = document.querySelectorAll('.card--load');

    if(typeof(cardsLoad) != 'undefined' && cardsLoad != null) {
      cardsLoad.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();
  
          if(!isMobile()) {
            var html = `
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>`;
  
            this.parentNode.insertAdjacentHTML("afterbegin", html);
          } else {
            var html = `
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>
              <div class="card card--simple">
                <a href="#" class="card__wrapper">
                  <div class="card__image">
                    <img src="/public/card--simple.jpg" alt="Card Simple">
                  </div>
              
                  <div class="card__content">
                    <p class="card__title">Azeites <span>34</span></p>
                  </div>
                </a>
              
                <a href="#" class="card__topic-link">
                  + Alimentação
                </a>
              </div>`;
  
            this.parentNode.insertAdjacentHTML("afterbegin", html);
          }
        });
      });
    }
  }
};

const cardLoad = new CardLoad();